module.exports = __webpack_public_path__ + "img/WingPay.aa3a0441.png";